export enum ElectricityMeterTypes {
  Standard = 0,
  Smart = 2,
  DayNight = 3,
  DayNightPeak = 4,
  StandardNightSaver = 5,
}
